var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CalendarDots component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCalendarDots extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.53784 1.10498C6.95206 1.10498 7.28784 1.44077 7.28784 1.85498V3.4458H16.7131V1.85498C16.7131 1.44077 17.0489 1.10498 17.4631 1.10498C17.8773 1.10498 18.2131 1.44077 18.2131 1.85498V3.4458H20.5848C21.1976 3.4458 21.7855 3.68924 22.2188 4.12265C22.652 4.55593 22.8956 5.14364 22.8956 5.75658V20.584C22.8956 21.1968 22.652 21.7847 22.2188 22.2179C21.7855 22.6512 21.1977 22.8948 20.5848 22.8948H3.41625C2.80331 22.8948 2.21561 22.6512 1.78233 22.218C1.3489 21.7846 1.10547 21.1968 1.10547 20.584V5.75658C1.10547 5.14371 1.34894 4.55595 1.78229 4.1226C2.21564 3.68927 2.80338 3.4458 3.41625 3.4458H5.78784V1.85498C5.78784 1.44077 6.12363 1.10498 6.53784 1.10498ZM16.7131 4.9458V6.53732C16.7131 6.95153 17.0489 7.28732 17.4631 7.28732C17.8773 7.28732 18.2131 6.95153 18.2131 6.53732V4.9458H20.5848C20.7999 4.9458 21.0061 5.03125 21.1581 5.18323C21.3102 5.33536 21.3956 5.54163 21.3956 5.75658V20.584C21.3956 20.799 21.3101 21.0053 21.1581 21.1573C21.0061 21.3093 20.7998 21.3948 20.5848 21.3948H3.41625C3.20129 21.3948 2.99502 21.3093 2.84289 21.1572C2.69092 21.0053 2.60547 20.799 2.60547 20.584V5.75658C2.60547 5.54155 2.69088 5.33534 2.84293 5.18328C2.99499 5.03123 3.20122 4.9458 3.41625 4.9458H5.78784V6.53732C5.78784 6.95153 6.12363 7.28732 6.53784 7.28732C6.95206 7.28732 7.28784 6.95153 7.28784 6.53732V4.9458H16.7131Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.53711 9.62842C5.84676 9.62842 5.28711 10.1881 5.28711 10.8784C5.28711 11.5688 5.84676 12.1284 6.53711 12.1284C7.22746 12.1284 7.78711 11.5688 7.78711 10.8784C7.78711 10.1881 7.22746 9.62842 6.53711 9.62842ZM12 9.62842C11.3096 9.62842 10.75 10.1881 10.75 10.8784C10.75 11.5688 11.3096 12.1284 12 12.1284C12.6904 12.1284 13.25 11.5688 13.25 10.8784C13.25 10.1881 12.6904 9.62842 12 9.62842ZM17.4626 9.62842C16.7724 9.62842 16.2126 10.188 16.2126 10.8784C16.2126 11.5688 16.7724 12.1284 17.4626 12.1284C18.1529 12.1284 18.7126 11.5688 18.7126 10.8784C18.7126 10.188 18.1529 9.62842 17.4626 9.62842ZM6.53711 15.8713C5.84676 15.8713 5.28711 16.431 5.28711 17.1213C5.28711 17.8116 5.84672 18.3713 6.53711 18.3713C7.2275 18.3713 7.78711 17.8116 7.78711 17.1213C7.78711 16.431 7.22746 15.8713 6.53711 15.8713ZM12 15.8713C11.3096 15.8713 10.75 16.431 10.75 17.1213C10.75 17.8116 11.3096 18.3713 12 18.3713C12.6904 18.3713 13.25 17.8116 13.25 17.1213C13.25 16.431 12.6904 15.8713 12 15.8713Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCalendarDots.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCalendarDots.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCalendarDots.prototype, "size", void 0);
if (customElements.get('cat-icon-calendar-dots') === undefined) {
    customElements.define('cat-icon-calendar-dots', BlocksIconCalendarDots);
}
